import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const D365ProjectOperationsIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1913 1022q0 43-23 80l-475 744q-21 32-54 50t-72 19H280q-31 0-58-11t-47-32-33-48-12-58V277q0-31 12-58t32-47 48-32 58-12h1009q38 0 72 18t54 51l475 744q23 37 23 81zM280 1787h146q7-12 30-50t56-94 73-121 80-135 79-132 67-115 48-83 18-35q0-3-18-35t-47-83-68-115-79-133-81-134-73-122-56-93-31-51H280q-8 0-15 6t-7 15v1489q0 9 6 15t16 6zm295 0h296q7-12 31-50t57-94 75-122 83-135 81-132 69-115 49-83 19-34q0-2-18-34t-49-82-70-116-82-133-83-135-76-122-57-94-31-50H573l411 689q21 35 21 77 0 20-5 39t-16 37l-409 689zm1211-765q0-3-19-34t-50-82-72-114-84-131-85-133-78-120-59-92-32-50q-7-10-18-10h-270l421 688q11 18 17 38t6 40q0 42-22 78l-420 687h268q11 0 18-10 7-12 31-50t60-92 77-120 86-133 83-130 72-114 51-81 19-35z" />
    </svg>
  ),
  displayName: 'D365ProjectOperationsIcon',
});

export default D365ProjectOperationsIcon;
